import "./style.css";
import React, { lazy, Suspense, useState } from "react";
import Particles from "../Particles/Particles";
import pteThinkingImage from "../../assets/ietls-thinking.webp";
import TestForm from "../../Components/TestForm";

const Modal = lazy(() => import("../../Components/Modal/Modal"));

const pteScores = [
  { score: 6, range: "85-90", level: "Expert" },
  { score: 5, range: "76-84", level: "Very Good" },
  { score: 4, range: "59-75", level: "Good" },
  { score: 3, range: "43-58", level: "Competent" },
  { score: 2, range: "30-42", level: "Modest" },
  { score: 1, range: "10-29", level: "Limited" },
];

const PTE = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Particles title="Know About PTE" subTitle="Information in PTE" />
      <div className="pte-information container">
        <div className="row">
          <div className="col-md-6 col-12 about-pte">
            <h2>What is PTE?</h2>
            <p>
              The Person Test of English (PTE) is an English language
              proficiency test designed for non-native English speakers who want
              to study, work, or migrate to English-speaking countries. PTE is
              fully computer-based and uses AI scoring for fair and fast
              results. It is accepted by thousands of universities, governments,
              and organizations worldwide.
            </p>
          </div>
          <div className="col-md-6 d-none d-md-block">
            <div className="image-container">
              <img src={pteThinkingImage} alt="pte-image" />
            </div>
          </div>
        </div>
        <div className="row justify-content-between px-0">
          <div className="col-12 col-lg-9">
            <div className="test-format">
              <h2>Test Format & Sections</h2>
              <p>The PTE test consists of four sections:</p>
              <ol>
                <li>
                  <strong className="sub-heading">
                    Speaking & Writing (77–93 minutes)
                  </strong>
                  <ul>
                    <li>
                      <strong>Speaking Tasks:</strong>
                      <ul>
                        <li>Read Aloud</li>
                        <li>Repeat Sentence</li>
                        <li>Describe Image</li>
                        <li>Re-tell Lecture</li>
                        <li>Answer Short Questions</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Writing Tasks:</strong>
                      <ul>
                        <li>Summarize Written Text</li>
                        <li>Write Essay</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong className="sub-heading">
                    Reading (32–41 minutes)
                  </strong>
                  <ul>
                    <li>Multiple-choice (single and multiple answers)</li>
                    <li>Re-order Paragraphs</li>
                    <li>Fill in the Blanks</li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong className="sub-heading">
                    Listening (45–57 minutes)
                  </strong>
                  <ul>
                    <li>Summarize Spoken Text</li>
                    <li>Multiple-choice Questions</li>
                    <li>Fill in the Blanks</li>
                    <li>Highlight Correct Summary</li>
                    <li>Select Missing Word</li>
                    <li>Write from Dictation</li>
                  </ul>
                </li>
              </ol>
            </div>
            <br />
            <div className="scoring-system">
              <h2>Scoring System</h2>
              <p>
                PTE scores range from 10 to 90, showing your English ability.
                The score scale is:
              </p>
              <br />

              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Score Range</th>
                    <th>Proficiency Level</th>
                  </tr>
                </thead>
                <tbody>
                  {pteScores?.map((pte) => (
                    <tr key={pte.score}>
                      <td className={`pte-band-score-${pte.score}`}>
                        {pte.range}
                      </td>
                      <td className={`pte-band-score-${pte.score}`}>
                        {pte.level}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-6 col-lg-3 mt-3 my-lg-4 align-items-start d-flex">
            <div className="register-card">
              <h1>Take PTE Class</h1>
              <button
                type="button"
                className="btn btn-md join-button"
                onClick={() => setShowModal(true)}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Suspense fallback={<></>}>
          <Modal
            showModal={showModal}
            setShowModal={setShowModal}
            header={"Join PTE"}
          >
            <TestForm setShowModal={setShowModal} preferredClass="PTE" />
          </Modal>
        </Suspense>
      )}
    </>
  );
};

export default PTE;
